/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * Expenses management API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AnalyzeReceiptBody,
  BankDetailsNoticeSettings,
  BankDetailsNoticeTestResult,
  BankDetailsNoticeToggle,
  BankStatementUpload,
  BankStatementUploadInput,
  BreakdownResult,
  Cardholder,
  ConfirmBankReconciliationCoverage200,
  ConfirmBankReconciliationCoverageBody,
  CourierCollectionCheckReport,
  CourierCollectionFeeConfig,
  CourierCollectionFeeSettings,
  CourierCollectionLookupInput,
  CreateBankReconciliationMonth201,
  CreateBankReconciliationMonthBody,
  CreateNominalTemplateBody,
  DecideBankReconciliation201,
  DecideBankReconciliationBody,
  DeleteNominalAssignmentsForEntry200,
  DeleteNominalTemplate200,
  ErrorResponse,
  ExportBankReconciliation200,
  GetBankReconciliationPeriod200,
  GetBankReconciliationPeriods200,
  GetCustomerRefundHolds200,
  GetProfitLossParams,
  HealthStatus,
  ImportBankReconciliation201,
  ImportBankReconciliationBody,
  ListMatchFailuresParams,
  ListReceiptsParams,
  ManualAssignBody,
  MatchFailure,
  MatchResult,
  MessageResponse,
  NominalAssignment,
  NominalTemplate,
  PodCollectionList,
  ProfitLossReport,
  RebuildProfitLossMonthBody,
  Receipt,
  ReleaseCustomerRefundHold200,
  ReminderResult,
  ReopenBankReconciliation200,
  ReopenBankReconciliationBody,
  ResolveMatchBody,
  SaveNominalAssignmentBody,
  SearchPodCollectionsParams,
  SignoffBankReconciliation200,
  SignoffBankReconciliationBody,
  SmtpSettings,
  SmtpSettingsBody,
  Statement,
  StatementWithEntries,
  SyncBankReconciliation200,
  UpdateCardholderBody,
  UploadReceiptBody,
  UploadStatementBody,
  User,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Read saved collection calculations and lookup corrections
 */
export const getGetCourierCollectionChecksUrl = (id: number) => {
  return `/api/courier-invoices/invoices/${id}/collection-checks`;
};

export const getCourierCollectionChecks = async (
  id: number,
  options?: RequestInit,
): Promise<CourierCollectionCheckReport> => {
  return customFetch<CourierCollectionCheckReport>(
    getGetCourierCollectionChecksUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetCourierCollectionChecksQueryKey = (id: number) => {
  return [`/api/courier-invoices/invoices/${id}/collection-checks`] as const;
};

export const getGetCourierCollectionChecksQueryOptions = <
  TData = Awaited<ReturnType<typeof getCourierCollectionChecks>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCourierCollectionChecks>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCourierCollectionChecksQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCourierCollectionChecks>>
  > = ({ signal }) =>
    getCourierCollectionChecks(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCourierCollectionChecks>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCourierCollectionChecksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCourierCollectionChecks>>
>;
export type GetCourierCollectionChecksQueryError = ErrorType<void>;

/**
 * @summary Read saved collection calculations and lookup corrections
 */

export function useGetCourierCollectionChecks<
  TData = Awaited<ReturnType<typeof getCourierCollectionChecks>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCourierCollectionChecks>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCourierCollectionChecksQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Save an audited, evidenced collection lookup correction without altering invoice identifiers
 */
export const getUpdateCourierCollectionLookupUrl = (
  id: number,
  lineId: number,
) => {
  return `/api/courier-invoices/invoices/${id}/lines/${lineId}/collection-lookup`;
};

export const updateCourierCollectionLookup = async (
  id: number,
  lineId: number,
  courierCollectionLookupInput: CourierCollectionLookupInput,
  options?: RequestInit,
): Promise<CourierCollectionCheckReport> => {
  return customFetch<CourierCollectionCheckReport>(
    getUpdateCourierCollectionLookupUrl(id, lineId),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(courierCollectionLookupInput),
    },
  );
};

export const getUpdateCourierCollectionLookupMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCourierCollectionLookup>>,
    TError,
    {
      id: number;
      lineId: number;
      data: BodyType<CourierCollectionLookupInput>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCourierCollectionLookup>>,
  TError,
  { id: number; lineId: number; data: BodyType<CourierCollectionLookupInput> },
  TContext
> => {
  const mutationKey = ["updateCourierCollectionLookup"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCourierCollectionLookup>>,
    { id: number; lineId: number; data: BodyType<CourierCollectionLookupInput> }
  > = (props) => {
    const { id, lineId, data } = props ?? {};

    return updateCourierCollectionLookup(id, lineId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCourierCollectionLookupMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCourierCollectionLookup>>
>;
export type UpdateCourierCollectionLookupMutationBody =
  BodyType<CourierCollectionLookupInput>;
export type UpdateCourierCollectionLookupMutationError = ErrorType<void>;

/**
 * @summary Save an audited, evidenced collection lookup correction without altering invoice identifiers
 */
export const useUpdateCourierCollectionLookup = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCourierCollectionLookup>>,
    TError,
    {
      id: number;
      lineId: number;
      data: BodyType<CourierCollectionLookupInput>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCourierCollectionLookup>>,
  TError,
  { id: number; lineId: number; data: BodyType<CourierCollectionLookupInput> },
  TContext
> => {
  return useMutation(getUpdateCourierCollectionLookupMutationOptions(options));
};

/**
 * @summary Read third-party collection fees and postcode reference information
 */
export const getGetCourierCollectionFeesUrl = (id: number) => {
  return `/api/courier-invoices/couriers/${id}/collection-fees`;
};

export const getCourierCollectionFees = async (
  id: number,
  options?: RequestInit,
): Promise<CourierCollectionFeeSettings> => {
  return customFetch<CourierCollectionFeeSettings>(
    getGetCourierCollectionFeesUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetCourierCollectionFeesQueryKey = (id: number) => {
  return [`/api/courier-invoices/couriers/${id}/collection-fees`] as const;
};

export const getGetCourierCollectionFeesQueryOptions = <
  TData = Awaited<ReturnType<typeof getCourierCollectionFees>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCourierCollectionFees>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCourierCollectionFeesQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCourierCollectionFees>>
  > = ({ signal }) =>
    getCourierCollectionFees(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCourierCollectionFees>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCourierCollectionFeesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCourierCollectionFees>>
>;
export type GetCourierCollectionFeesQueryError = ErrorType<void>;

/**
 * @summary Read third-party collection fees and postcode reference information
 */

export function useGetCourierCollectionFees<
  TData = Awaited<ReturnType<typeof getCourierCollectionFees>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCourierCollectionFees>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCourierCollectionFeesQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update collection fees for DHL or Evri Premium
 */
export const getUpdateCourierCollectionFeesUrl = (id: number) => {
  return `/api/courier-invoices/couriers/${id}/collection-fees`;
};

export const updateCourierCollectionFees = async (
  id: number,
  courierCollectionFeeConfig: CourierCollectionFeeConfig,
  options?: RequestInit,
): Promise<CourierCollectionFeeSettings> => {
  return customFetch<CourierCollectionFeeSettings>(
    getUpdateCourierCollectionFeesUrl(id),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(courierCollectionFeeConfig),
    },
  );
};

export const getUpdateCourierCollectionFeesMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCourierCollectionFees>>,
    TError,
    { id: number; data: BodyType<CourierCollectionFeeConfig> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCourierCollectionFees>>,
  TError,
  { id: number; data: BodyType<CourierCollectionFeeConfig> },
  TContext
> => {
  const mutationKey = ["updateCourierCollectionFees"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCourierCollectionFees>>,
    { id: number; data: BodyType<CourierCollectionFeeConfig> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateCourierCollectionFees(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCourierCollectionFeesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCourierCollectionFees>>
>;
export type UpdateCourierCollectionFeesMutationBody =
  BodyType<CourierCollectionFeeConfig>;
export type UpdateCourierCollectionFeesMutationError = ErrorType<void>;

/**
 * @summary Update collection fees for DHL or Evri Premium
 */
export const useUpdateCourierCollectionFees = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCourierCollectionFees>>,
    TError,
    { id: number; data: BodyType<CourierCollectionFeeConfig> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCourierCollectionFees>>,
  TError,
  { id: number; data: BodyType<CourierCollectionFeeConfig> },
  TContext
> => {
  return useMutation(getUpdateCourierCollectionFeesMutationOptions(options));
};

/**
 * @summary Monthly TSS and VERSA parts sales as a share of invoices with nonblank AINVHEAD.webref3
 */
export const getGetProfitLossUrl = (params: GetProfitLossParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/profit-loss?${stringifiedParams}`
    : `/api/profit-loss`;
};

export const getProfitLoss = async (
  params: GetProfitLossParams,
  options?: RequestInit,
): Promise<ProfitLossReport> => {
  return customFetch<ProfitLossReport>(getGetProfitLossUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetProfitLossQueryKey = (params?: GetProfitLossParams) => {
  return [`/api/profit-loss`, ...(params ? [params] : [])] as const;
};

export const getGetProfitLossQueryOptions = <
  TData = Awaited<ReturnType<typeof getProfitLoss>>,
  TError = ErrorType<void>,
>(
  params: GetProfitLossParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getProfitLoss>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProfitLossQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfitLoss>>> = ({
    signal,
  }) => getProfitLoss(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProfitLoss>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetProfitLossQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProfitLoss>>
>;
export type GetProfitLossQueryError = ErrorType<void>;

/**
 * @summary Monthly TSS and VERSA parts sales as a share of invoices with nonblank AINVHEAD.webref3
 */

export function useGetProfitLoss<
  TData = Awaited<ReturnType<typeof getProfitLoss>>,
  TError = ErrorType<void>,
>(
  params: GetProfitLossParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getProfitLoss>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetProfitLossQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Admin-only rebuild of saved P&L figures for one month
 */
export const getRebuildProfitLossMonthUrl = () => {
  return `/api/profit-loss/rebuild`;
};

export const rebuildProfitLossMonth = async (
  rebuildProfitLossMonthBody: RebuildProfitLossMonthBody,
  options?: RequestInit,
): Promise<ProfitLossReport> => {
  return customFetch<ProfitLossReport>(getRebuildProfitLossMonthUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(rebuildProfitLossMonthBody),
  });
};

export const getRebuildProfitLossMonthMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rebuildProfitLossMonth>>,
    TError,
    { data: BodyType<RebuildProfitLossMonthBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rebuildProfitLossMonth>>,
  TError,
  { data: BodyType<RebuildProfitLossMonthBody> },
  TContext
> => {
  const mutationKey = ["rebuildProfitLossMonth"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rebuildProfitLossMonth>>,
    { data: BodyType<RebuildProfitLossMonthBody> }
  > = (props) => {
    const { data } = props ?? {};

    return rebuildProfitLossMonth(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RebuildProfitLossMonthMutationResult = NonNullable<
  Awaited<ReturnType<typeof rebuildProfitLossMonth>>
>;
export type RebuildProfitLossMonthMutationBody =
  BodyType<RebuildProfitLossMonthBody>;
export type RebuildProfitLossMonthMutationError = ErrorType<void>;

/**
 * @summary Admin-only rebuild of saved P&L figures for one month
 */
export const useRebuildProfitLossMonth = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rebuildProfitLossMonth>>,
    TError,
    { data: BodyType<RebuildProfitLossMonthBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof rebuildProfitLossMonth>>,
  TError,
  { data: BodyType<RebuildProfitLossMonthBody> },
  TContext
> => {
  return useMutation(getRebuildProfitLossMonthMutationOptions(options));
};

/**
 * @summary Refresh Stripe and Adflex review queues and list customer-wide refund holds
 */
export const getGetCustomerRefundHoldsUrl = () => {
  return `/api/stripe-refunds/on-hold`;
};

export const getCustomerRefundHolds = async (
  options?: RequestInit,
): Promise<GetCustomerRefundHolds200> => {
  return customFetch<GetCustomerRefundHolds200>(
    getGetCustomerRefundHoldsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetCustomerRefundHoldsQueryKey = () => {
  return [`/api/stripe-refunds/on-hold`] as const;
};

export const getGetCustomerRefundHoldsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerRefundHolds>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerRefundHolds>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCustomerRefundHoldsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCustomerRefundHolds>>
  > = ({ signal }) => getCustomerRefundHolds({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerRefundHolds>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCustomerRefundHoldsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerRefundHolds>>
>;
export type GetCustomerRefundHoldsQueryError = ErrorType<unknown>;

/**
 * @summary Refresh Stripe and Adflex review queues and list customer-wide refund holds
 */

export function useGetCustomerRefundHolds<
  TData = Awaited<ReturnType<typeof getCustomerRefundHolds>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerRefundHolds>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCustomerRefundHoldsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Human-reviewed release after live customer stop flag is verified as zero; never issues money
 */
export const getReleaseCustomerRefundHoldUrl = (account: string) => {
  return `/api/stripe-refunds/on-hold/${account}/release`;
};

export const releaseCustomerRefundHold = async (
  account: string,
  options?: RequestInit,
): Promise<ReleaseCustomerRefundHold200> => {
  return customFetch<ReleaseCustomerRefundHold200>(
    getReleaseCustomerRefundHoldUrl(account),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getReleaseCustomerRefundHoldMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof releaseCustomerRefundHold>>,
    TError,
    { account: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof releaseCustomerRefundHold>>,
  TError,
  { account: string },
  TContext
> => {
  const mutationKey = ["releaseCustomerRefundHold"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof releaseCustomerRefundHold>>,
    { account: string }
  > = (props) => {
    const { account } = props ?? {};

    return releaseCustomerRefundHold(account, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReleaseCustomerRefundHoldMutationResult = NonNullable<
  Awaited<ReturnType<typeof releaseCustomerRefundHold>>
>;

export type ReleaseCustomerRefundHoldMutationError = ErrorType<void>;

/**
 * @summary Human-reviewed release after live customer stop flag is verified as zero; never issues money
 */
export const useReleaseCustomerRefundHold = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof releaseCustomerRefundHold>>,
    TError,
    { account: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof releaseCustomerRefundHold>>,
  TError,
  { account: string },
  TContext
> => {
  return useMutation(getReleaseCustomerRefundHoldMutationOptions(options));
};

/**
 * @summary List retained 17012 reconciliation periods and Finance permissions
 */
export const getGetBankReconciliationPeriodsUrl = () => {
  return `/api/bank-reconciliation/periods`;
};

export const getBankReconciliationPeriods = async (
  options?: RequestInit,
): Promise<GetBankReconciliationPeriods200> => {
  return customFetch<GetBankReconciliationPeriods200>(
    getGetBankReconciliationPeriodsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetBankReconciliationPeriodsQueryKey = () => {
  return [`/api/bank-reconciliation/periods`] as const;
};

export const getGetBankReconciliationPeriodsQueryOptions = <
  TData = Awaited<ReturnType<typeof getBankReconciliationPeriods>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getBankReconciliationPeriods>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBankReconciliationPeriodsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBankReconciliationPeriods>>
  > = ({ signal }) =>
    getBankReconciliationPeriods({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBankReconciliationPeriods>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBankReconciliationPeriodsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBankReconciliationPeriods>>
>;
export type GetBankReconciliationPeriodsQueryError = ErrorType<unknown>;

/**
 * @summary List retained 17012 reconciliation periods and Finance permissions
 */

export function useGetBankReconciliationPeriods<
  TData = Awaited<ReturnType<typeof getBankReconciliationPeriods>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getBankReconciliationPeriods>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBankReconciliationPeriodsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Retain and validate a Payment Account CSV without posting cash
 */
export const getImportBankReconciliationUrl = () => {
  return `/api/bank-reconciliation/imports`;
};

export const importBankReconciliation = async (
  importBankReconciliationBody: ImportBankReconciliationBody,
  options?: RequestInit,
): Promise<ImportBankReconciliation201> => {
  const formData = new FormData();
  formData.append(`file`, importBankReconciliationBody.file);
  formData.append(`account`, importBankReconciliationBody.account);

  return customFetch<ImportBankReconciliation201>(
    getImportBankReconciliationUrl(),
    {
      ...options,
      method: "POST",
      body: formData,
    },
  );
};

export const getImportBankReconciliationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importBankReconciliation>>,
    TError,
    { data: BodyType<ImportBankReconciliationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof importBankReconciliation>>,
  TError,
  { data: BodyType<ImportBankReconciliationBody> },
  TContext
> => {
  const mutationKey = ["importBankReconciliation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof importBankReconciliation>>,
    { data: BodyType<ImportBankReconciliationBody> }
  > = (props) => {
    const { data } = props ?? {};

    return importBankReconciliation(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ImportBankReconciliationMutationResult = NonNullable<
  Awaited<ReturnType<typeof importBankReconciliation>>
>;
export type ImportBankReconciliationMutationBody =
  BodyType<ImportBankReconciliationBody>;
export type ImportBankReconciliationMutationError = ErrorType<unknown>;

/**
 * @summary Retain and validate a Payment Account CSV without posting cash
 */
export const useImportBankReconciliation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importBankReconciliation>>,
    TError,
    { data: BodyType<ImportBankReconciliationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof importBankReconciliation>>,
  TError,
  { data: BodyType<ImportBankReconciliationBody> },
  TContext
> => {
  return useMutation(getImportBankReconciliationMutationOptions(options));
};

/**
 * @summary Open a month-end review
 */
export const getCreateBankReconciliationMonthUrl = () => {
  return `/api/bank-reconciliation/months`;
};

export const createBankReconciliationMonth = async (
  createBankReconciliationMonthBody: CreateBankReconciliationMonthBody,
  options?: RequestInit,
): Promise<CreateBankReconciliationMonth201> => {
  return customFetch<CreateBankReconciliationMonth201>(
    getCreateBankReconciliationMonthUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(createBankReconciliationMonthBody),
    },
  );
};

export const getCreateBankReconciliationMonthMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBankReconciliationMonth>>,
    TError,
    { data: BodyType<CreateBankReconciliationMonthBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBankReconciliationMonth>>,
  TError,
  { data: BodyType<CreateBankReconciliationMonthBody> },
  TContext
> => {
  const mutationKey = ["createBankReconciliationMonth"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBankReconciliationMonth>>,
    { data: BodyType<CreateBankReconciliationMonthBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createBankReconciliationMonth(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBankReconciliationMonthMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBankReconciliationMonth>>
>;
export type CreateBankReconciliationMonthMutationBody =
  BodyType<CreateBankReconciliationMonthBody>;
export type CreateBankReconciliationMonthMutationError = ErrorType<unknown>;

/**
 * @summary Open a month-end review
 */
export const useCreateBankReconciliationMonth = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBankReconciliationMonth>>,
    TError,
    { data: BodyType<CreateBankReconciliationMonthBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createBankReconciliationMonth>>,
  TError,
  { data: BodyType<CreateBankReconciliationMonthBody> },
  TContext
> => {
  return useMutation(getCreateBankReconciliationMonthMutationOptions(options));
};

/**
 * @summary Two-way bank, nominal and settlement evidence and decision history
 */
export const getGetBankReconciliationPeriodUrl = (id: number) => {
  return `/api/bank-reconciliation/periods/${id}`;
};

export const getBankReconciliationPeriod = async (
  id: number,
  options?: RequestInit,
): Promise<GetBankReconciliationPeriod200> => {
  return customFetch<GetBankReconciliationPeriod200>(
    getGetBankReconciliationPeriodUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetBankReconciliationPeriodQueryKey = (id: number) => {
  return [`/api/bank-reconciliation/periods/${id}`] as const;
};

export const getGetBankReconciliationPeriodQueryOptions = <
  TData = Awaited<ReturnType<typeof getBankReconciliationPeriod>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBankReconciliationPeriod>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBankReconciliationPeriodQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBankReconciliationPeriod>>
  > = ({ signal }) =>
    getBankReconciliationPeriod(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBankReconciliationPeriod>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBankReconciliationPeriodQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBankReconciliationPeriod>>
>;
export type GetBankReconciliationPeriodQueryError = ErrorType<unknown>;

/**
 * @summary Two-way bank, nominal and settlement evidence and decision history
 */

export function useGetBankReconciliationPeriod<
  TData = Awaited<ReturnType<typeof getBankReconciliationPeriod>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBankReconciliationPeriod>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBankReconciliationPeriodQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Read and retain complete Merlin and Stripe evidence without posting
 */
export const getSyncBankReconciliationUrl = (id: number) => {
  return `/api/bank-reconciliation/periods/${id}/sync`;
};

export const syncBankReconciliation = async (
  id: number,
  options?: RequestInit,
): Promise<SyncBankReconciliation200> => {
  return customFetch<SyncBankReconciliation200>(
    getSyncBankReconciliationUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getSyncBankReconciliationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof syncBankReconciliation>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof syncBankReconciliation>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["syncBankReconciliation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof syncBankReconciliation>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return syncBankReconciliation(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SyncBankReconciliationMutationResult = NonNullable<
  Awaited<ReturnType<typeof syncBankReconciliation>>
>;

export type SyncBankReconciliationMutationError = ErrorType<unknown>;

/**
 * @summary Read and retain complete Merlin and Stripe evidence without posting
 */
export const useSyncBankReconciliation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof syncBankReconciliation>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof syncBankReconciliation>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getSyncBankReconciliationMutationOptions(options));
};

/**
 * @summary Append an authorised evidence-backed Finance decision
 */
export const getDecideBankReconciliationUrl = (id: number) => {
  return `/api/bank-reconciliation/periods/${id}/decisions`;
};

export const decideBankReconciliation = async (
  id: number,
  decideBankReconciliationBody: DecideBankReconciliationBody,
  options?: RequestInit,
): Promise<DecideBankReconciliation201> => {
  return customFetch<DecideBankReconciliation201>(
    getDecideBankReconciliationUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(decideBankReconciliationBody),
    },
  );
};

export const getDecideBankReconciliationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof decideBankReconciliation>>,
    TError,
    { id: number; data: BodyType<DecideBankReconciliationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof decideBankReconciliation>>,
  TError,
  { id: number; data: BodyType<DecideBankReconciliationBody> },
  TContext
> => {
  const mutationKey = ["decideBankReconciliation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof decideBankReconciliation>>,
    { id: number; data: BodyType<DecideBankReconciliationBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return decideBankReconciliation(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DecideBankReconciliationMutationResult = NonNullable<
  Awaited<ReturnType<typeof decideBankReconciliation>>
>;
export type DecideBankReconciliationMutationBody =
  BodyType<DecideBankReconciliationBody>;
export type DecideBankReconciliationMutationError = ErrorType<unknown>;

/**
 * @summary Append an authorised evidence-backed Finance decision
 */
export const useDecideBankReconciliation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof decideBankReconciliation>>,
    TError,
    { id: number; data: BodyType<DecideBankReconciliationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof decideBankReconciliation>>,
  TError,
  { id: number; data: BodyType<DecideBankReconciliationBody> },
  TContext
> => {
  return useMutation(getDecideBankReconciliationMutationOptions(options));
};

/**
 * @summary Confirm source completeness and evidence-based closing balance
 */
export const getConfirmBankReconciliationCoverageUrl = (id: number) => {
  return `/api/bank-reconciliation/periods/${id}/confirm`;
};

export const confirmBankReconciliationCoverage = async (
  id: number,
  confirmBankReconciliationCoverageBody: ConfirmBankReconciliationCoverageBody,
  options?: RequestInit,
): Promise<ConfirmBankReconciliationCoverage200> => {
  return customFetch<ConfirmBankReconciliationCoverage200>(
    getConfirmBankReconciliationCoverageUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(confirmBankReconciliationCoverageBody),
    },
  );
};

export const getConfirmBankReconciliationCoverageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmBankReconciliationCoverage>>,
    TError,
    { id: number; data: BodyType<ConfirmBankReconciliationCoverageBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmBankReconciliationCoverage>>,
  TError,
  { id: number; data: BodyType<ConfirmBankReconciliationCoverageBody> },
  TContext
> => {
  const mutationKey = ["confirmBankReconciliationCoverage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmBankReconciliationCoverage>>,
    { id: number; data: BodyType<ConfirmBankReconciliationCoverageBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return confirmBankReconciliationCoverage(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConfirmBankReconciliationCoverageMutationResult = NonNullable<
  Awaited<ReturnType<typeof confirmBankReconciliationCoverage>>
>;
export type ConfirmBankReconciliationCoverageMutationBody =
  BodyType<ConfirmBankReconciliationCoverageBody>;
export type ConfirmBankReconciliationCoverageMutationError = ErrorType<unknown>;

/**
 * @summary Confirm source completeness and evidence-based closing balance
 */
export const useConfirmBankReconciliationCoverage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmBankReconciliationCoverage>>,
    TError,
    { id: number; data: BodyType<ConfirmBankReconciliationCoverageBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof confirmBankReconciliationCoverage>>,
  TError,
  { id: number; data: BodyType<ConfirmBankReconciliationCoverageBody> },
  TContext
> => {
  return useMutation(
    getConfirmBankReconciliationCoverageMutationOptions(options),
  );
};

/**
 * @summary Independent month-end Finance signoff with immutable snapshot
 */
export const getSignoffBankReconciliationUrl = (id: number) => {
  return `/api/bank-reconciliation/periods/${id}/signoff`;
};

export const signoffBankReconciliation = async (
  id: number,
  signoffBankReconciliationBody: SignoffBankReconciliationBody,
  options?: RequestInit,
): Promise<SignoffBankReconciliation200> => {
  return customFetch<SignoffBankReconciliation200>(
    getSignoffBankReconciliationUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(signoffBankReconciliationBody),
    },
  );
};

export const getSignoffBankReconciliationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signoffBankReconciliation>>,
    TError,
    { id: number; data: BodyType<SignoffBankReconciliationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof signoffBankReconciliation>>,
  TError,
  { id: number; data: BodyType<SignoffBankReconciliationBody> },
  TContext
> => {
  const mutationKey = ["signoffBankReconciliation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof signoffBankReconciliation>>,
    { id: number; data: BodyType<SignoffBankReconciliationBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return signoffBankReconciliation(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SignoffBankReconciliationMutationResult = NonNullable<
  Awaited<ReturnType<typeof signoffBankReconciliation>>
>;
export type SignoffBankReconciliationMutationBody =
  BodyType<SignoffBankReconciliationBody>;
export type SignoffBankReconciliationMutationError = ErrorType<unknown>;

/**
 * @summary Independent month-end Finance signoff with immutable snapshot
 */
export const useSignoffBankReconciliation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signoffBankReconciliation>>,
    TError,
    { id: number; data: BodyType<SignoffBankReconciliationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof signoffBankReconciliation>>,
  TError,
  { id: number; data: BodyType<SignoffBankReconciliationBody> },
  TContext
> => {
  return useMutation(getSignoffBankReconciliationMutationOptions(options));
};

/**
 * @summary Authorised reopening retaining previous signoff and reason
 */
export const getReopenBankReconciliationUrl = (id: number) => {
  return `/api/bank-reconciliation/periods/${id}/reopen`;
};

export const reopenBankReconciliation = async (
  id: number,
  reopenBankReconciliationBody: ReopenBankReconciliationBody,
  options?: RequestInit,
): Promise<ReopenBankReconciliation200> => {
  return customFetch<ReopenBankReconciliation200>(
    getReopenBankReconciliationUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(reopenBankReconciliationBody),
    },
  );
};

export const getReopenBankReconciliationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reopenBankReconciliation>>,
    TError,
    { id: number; data: BodyType<ReopenBankReconciliationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reopenBankReconciliation>>,
  TError,
  { id: number; data: BodyType<ReopenBankReconciliationBody> },
  TContext
> => {
  const mutationKey = ["reopenBankReconciliation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reopenBankReconciliation>>,
    { id: number; data: BodyType<ReopenBankReconciliationBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return reopenBankReconciliation(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReopenBankReconciliationMutationResult = NonNullable<
  Awaited<ReturnType<typeof reopenBankReconciliation>>
>;
export type ReopenBankReconciliationMutationBody =
  BodyType<ReopenBankReconciliationBody>;
export type ReopenBankReconciliationMutationError = ErrorType<unknown>;

/**
 * @summary Authorised reopening retaining previous signoff and reason
 */
export const useReopenBankReconciliation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reopenBankReconciliation>>,
    TError,
    { id: number; data: BodyType<ReopenBankReconciliationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reopenBankReconciliation>>,
  TError,
  { id: number; data: BodyType<ReopenBankReconciliationBody> },
  TContext
> => {
  return useMutation(getReopenBankReconciliationMutationOptions(options));
};

/**
 * @summary Download retained reproducible auditor evidence without edit access
 */
export const getExportBankReconciliationUrl = (id: number) => {
  return `/api/bank-reconciliation/periods/${id}/export`;
};

export const exportBankReconciliation = async (
  id: number,
  options?: RequestInit,
): Promise<ExportBankReconciliation200> => {
  return customFetch<ExportBankReconciliation200>(
    getExportBankReconciliationUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getExportBankReconciliationQueryKey = (id: number) => {
  return [`/api/bank-reconciliation/periods/${id}/export`] as const;
};

export const getExportBankReconciliationQueryOptions = <
  TData = Awaited<ReturnType<typeof exportBankReconciliation>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof exportBankReconciliation>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getExportBankReconciliationQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof exportBankReconciliation>>
  > = ({ signal }) =>
    exportBankReconciliation(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof exportBankReconciliation>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExportBankReconciliationQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportBankReconciliation>>
>;
export type ExportBankReconciliationQueryError = ErrorType<unknown>;

/**
 * @summary Download retained reproducible auditor evidence without edit access
 */

export function useExportBankReconciliation<
  TData = Awaited<ReturnType<typeof exportBankReconciliation>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof exportBankReconciliation>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getExportBankReconciliationQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Authorised private download of the original statement
 */
export const getDownloadBankReconciliationSourceUrl = (id: number) => {
  return `/api/bank-reconciliation/imports/${id}/file`;
};

export const downloadBankReconciliationSource = async (
  id: number,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getDownloadBankReconciliationSourceUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getDownloadBankReconciliationSourceQueryKey = (id: number) => {
  return [`/api/bank-reconciliation/imports/${id}/file`] as const;
};

export const getDownloadBankReconciliationSourceQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadBankReconciliationSource>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadBankReconciliationSource>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDownloadBankReconciliationSourceQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadBankReconciliationSource>>
  > = ({ signal }) =>
    downloadBankReconciliationSource(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadBankReconciliationSource>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DownloadBankReconciliationSourceQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadBankReconciliationSource>>
>;
export type DownloadBankReconciliationSourceQueryError = ErrorType<unknown>;

/**
 * @summary Authorised private download of the original statement
 */

export function useDownloadBankReconciliationSource<
  TData = Awaited<ReturnType<typeof downloadBankReconciliationSource>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadBankReconciliationSource>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDownloadBankReconciliationSourceQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List bank uploads for both accounts
 */
export const getListBankStatementUploadsUrl = () => {
  return `/api/cash-receipts/bank-statements`;
};

export const listBankStatementUploads = async (
  options?: RequestInit,
): Promise<BankStatementUpload[]> => {
  return customFetch<BankStatementUpload[]>(getListBankStatementUploadsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListBankStatementUploadsQueryKey = () => {
  return [`/api/cash-receipts/bank-statements`] as const;
};

export const getListBankStatementUploadsQueryOptions = <
  TData = Awaited<ReturnType<typeof listBankStatementUploads>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listBankStatementUploads>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListBankStatementUploadsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listBankStatementUploads>>
  > = ({ signal }) => listBankStatementUploads({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listBankStatementUploads>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListBankStatementUploadsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBankStatementUploads>>
>;
export type ListBankStatementUploadsQueryError = ErrorType<unknown>;

/**
 * @summary List bank uploads for both accounts
 */

export function useListBankStatementUploads<
  TData = Awaited<ReturnType<typeof listBankStatementUploads>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listBankStatementUploads>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListBankStatementUploadsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Import an existing-account CSV or Current account XLSX
 */
export const getUploadBankStatementUrl = () => {
  return `/api/cash-receipts/bank-statements/upload`;
};

export const uploadBankStatement = async (
  bankStatementUploadInput: BankStatementUploadInput,
  options?: RequestInit,
): Promise<BankStatementUpload> => {
  const formData = new FormData();
  formData.append(`file`, bankStatementUploadInput.file);
  if (bankStatementUploadInput.source !== undefined) {
    formData.append(`source`, bankStatementUploadInput.source);
  }

  return customFetch<BankStatementUpload>(getUploadBankStatementUrl(), {
    ...options,
    method: "POST",
    body: formData,
  });
};

export const getUploadBankStatementMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadBankStatement>>,
    TError,
    { data: BodyType<BankStatementUploadInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadBankStatement>>,
  TError,
  { data: BodyType<BankStatementUploadInput> },
  TContext
> => {
  const mutationKey = ["uploadBankStatement"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadBankStatement>>,
    { data: BodyType<BankStatementUploadInput> }
  > = (props) => {
    const { data } = props ?? {};

    return uploadBankStatement(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadBankStatementMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadBankStatement>>
>;
export type UploadBankStatementMutationBody =
  BodyType<BankStatementUploadInput>;
export type UploadBankStatementMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Import an existing-account CSV or Current account XLSX
 */
export const useUploadBankStatement = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadBankStatement>>,
    TError,
    { data: BodyType<BankStatementUploadInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof uploadBankStatement>>,
  TError,
  { data: BodyType<BankStatementUploadInput> },
  TContext
> => {
  return useMutation(getUploadBankStatementMutationOptions(options));
};

/**
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get current user
 */
export const getGetMeUrl = () => {
  return `/api/auth/me`;
};

export const getMe = async (options?: RequestInit): Promise<User> => {
  return customFetch<User>(getGetMeUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMeQueryKey = () => {
  return [`/api/auth/me`] as const;
};

export const getGetMeQueryOptions = <
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({
    signal,
  }) => getMe({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMe>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>;
export type GetMeQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get current user
 */

export function useGetMe<
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all uploaded statements
 */
export const getListStatementsUrl = () => {
  return `/api/statements`;
};

export const listStatements = async (
  options?: RequestInit,
): Promise<Statement[]> => {
  return customFetch<Statement[]>(getListStatementsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListStatementsQueryKey = () => {
  return [`/api/statements`] as const;
};

export const getListStatementsQueryOptions = <
  TData = Awaited<ReturnType<typeof listStatements>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listStatements>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListStatementsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listStatements>>> = ({
    signal,
  }) => listStatements({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listStatements>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListStatementsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listStatements>>
>;
export type ListStatementsQueryError = ErrorType<unknown>;

/**
 * @summary List all uploaded statements
 */

export function useListStatements<
  TData = Awaited<ReturnType<typeof listStatements>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listStatements>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListStatementsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Upload a PDF credit card statement
 */
export const getUploadStatementUrl = () => {
  return `/api/statements/upload`;
};

export const uploadStatement = async (
  uploadStatementBody: UploadStatementBody,
  options?: RequestInit,
): Promise<StatementWithEntries> => {
  const formData = new FormData();
  formData.append(`file`, uploadStatementBody.file);

  return customFetch<StatementWithEntries>(getUploadStatementUrl(), {
    ...options,
    method: "POST",
    body: formData,
  });
};

export const getUploadStatementMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadStatement>>,
    TError,
    { data: BodyType<UploadStatementBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadStatement>>,
  TError,
  { data: BodyType<UploadStatementBody> },
  TContext
> => {
  const mutationKey = ["uploadStatement"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadStatement>>,
    { data: BodyType<UploadStatementBody> }
  > = (props) => {
    const { data } = props ?? {};

    return uploadStatement(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadStatementMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadStatement>>
>;
export type UploadStatementMutationBody = BodyType<UploadStatementBody>;
export type UploadStatementMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Upload a PDF credit card statement
 */
export const useUploadStatement = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadStatement>>,
    TError,
    { data: BodyType<UploadStatementBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof uploadStatement>>,
  TError,
  { data: BodyType<UploadStatementBody> },
  TContext
> => {
  return useMutation(getUploadStatementMutationOptions(options));
};

/**
 * @summary Get statement with entries
 */
export const getGetStatementUrl = (id: number) => {
  return `/api/statements/${id}`;
};

export const getStatement = async (
  id: number,
  options?: RequestInit,
): Promise<StatementWithEntries> => {
  return customFetch<StatementWithEntries>(getGetStatementUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetStatementQueryKey = (id: number) => {
  return [`/api/statements/${id}`] as const;
};

export const getGetStatementQueryOptions = <
  TData = Awaited<ReturnType<typeof getStatement>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStatement>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStatementQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStatement>>> = ({
    signal,
  }) => getStatement(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStatement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStatementQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStatement>>
>;
export type GetStatementQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get statement with entries
 */

export function useGetStatement<
  TData = Awaited<ReturnType<typeof getStatement>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStatement>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStatementQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Download the original PDF statement
 */
export const getDownloadStatementUrl = (id: number) => {
  return `/api/statements/${id}/download`;
};

export const downloadStatement = async (
  id: number,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getDownloadStatementUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getDownloadStatementQueryKey = (id: number) => {
  return [`/api/statements/${id}/download`] as const;
};

export const getDownloadStatementQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadStatement>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadStatement>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDownloadStatementQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadStatement>>
  > = ({ signal }) => downloadStatement(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadStatement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DownloadStatementQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadStatement>>
>;
export type DownloadStatementQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Download the original PDF statement
 */

export function useDownloadStatement<
  TData = Awaited<ReturnType<typeof downloadStatement>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadStatement>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDownloadStatementQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Export the statement as an Excel file using assigned nominal codes
 */
export const getExportStatementNominalsUrl = (id: number) => {
  return `/api/statements/${id}/export-nominals`;
};

export const exportStatementNominals = async (
  id: number,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getExportStatementNominalsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getExportStatementNominalsQueryKey = (id: number) => {
  return [`/api/statements/${id}/export-nominals`] as const;
};

export const getExportStatementNominalsQueryOptions = <
  TData = Awaited<ReturnType<typeof exportStatementNominals>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof exportStatementNominals>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getExportStatementNominalsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof exportStatementNominals>>
  > = ({ signal }) =>
    exportStatementNominals(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof exportStatementNominals>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExportStatementNominalsQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportStatementNominals>>
>;
export type ExportStatementNominalsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Export the statement as an Excel file using assigned nominal codes
 */

export function useExportStatementNominals<
  TData = Awaited<ReturnType<typeof exportStatementNominals>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof exportStatementNominals>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getExportStatementNominalsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all uploaded receipts
 */
export const getListReceiptsUrl = (params?: ListReceiptsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/receipts?${stringifiedParams}`
    : `/api/receipts`;
};

export const listReceipts = async (
  params?: ListReceiptsParams,
  options?: RequestInit,
): Promise<Receipt[]> => {
  return customFetch<Receipt[]>(getListReceiptsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListReceiptsQueryKey = (params?: ListReceiptsParams) => {
  return [`/api/receipts`, ...(params ? [params] : [])] as const;
};

export const getListReceiptsQueryOptions = <
  TData = Awaited<ReturnType<typeof listReceipts>>,
  TError = ErrorType<unknown>,
>(
  params?: ListReceiptsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listReceipts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListReceiptsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listReceipts>>> = ({
    signal,
  }) => listReceipts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listReceipts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListReceiptsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listReceipts>>
>;
export type ListReceiptsQueryError = ErrorType<unknown>;

/**
 * @summary List all uploaded receipts
 */

export function useListReceipts<
  TData = Awaited<ReturnType<typeof listReceipts>>,
  TError = ErrorType<unknown>,
>(
  params?: ListReceiptsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listReceipts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListReceiptsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Upload a receipt (PDF or image)
 */
export const getUploadReceiptUrl = () => {
  return `/api/receipts/upload`;
};

export const uploadReceipt = async (
  uploadReceiptBody: UploadReceiptBody,
  options?: RequestInit,
): Promise<Receipt> => {
  const formData = new FormData();
  formData.append(`file`, uploadReceiptBody.file);

  return customFetch<Receipt>(getUploadReceiptUrl(), {
    ...options,
    method: "POST",
    body: formData,
  });
};

export const getUploadReceiptMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadReceipt>>,
    TError,
    { data: BodyType<UploadReceiptBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadReceipt>>,
  TError,
  { data: BodyType<UploadReceiptBody> },
  TContext
> => {
  const mutationKey = ["uploadReceipt"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadReceipt>>,
    { data: BodyType<UploadReceiptBody> }
  > = (props) => {
    const { data } = props ?? {};

    return uploadReceipt(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadReceiptMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadReceipt>>
>;
export type UploadReceiptMutationBody = BodyType<UploadReceiptBody>;
export type UploadReceiptMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Upload a receipt (PDF or image)
 */
export const useUploadReceipt = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadReceipt>>,
    TError,
    { data: BodyType<UploadReceiptBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof uploadReceipt>>,
  TError,
  { data: BodyType<UploadReceiptBody> },
  TContext
> => {
  return useMutation(getUploadReceiptMutationOptions(options));
};

/**
 * @summary Get receipt details
 */
export const getGetReceiptUrl = (id: number) => {
  return `/api/receipts/${id}`;
};

export const getReceipt = async (
  id: number,
  options?: RequestInit,
): Promise<Receipt> => {
  return customFetch<Receipt>(getGetReceiptUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetReceiptQueryKey = (id: number) => {
  return [`/api/receipts/${id}`] as const;
};

export const getGetReceiptQueryOptions = <
  TData = Awaited<ReturnType<typeof getReceipt>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getReceipt>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReceiptQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReceipt>>> = ({
    signal,
  }) => getReceipt(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getReceipt>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReceiptQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReceipt>>
>;
export type GetReceiptQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get receipt details
 */

export function useGetReceipt<
  TData = Awaited<ReturnType<typeof getReceipt>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getReceipt>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetReceiptQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Download receipt file
 */
export const getDownloadReceiptUrl = (id: number) => {
  return `/api/receipts/${id}/download`;
};

export const downloadReceipt = async (
  id: number,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getDownloadReceiptUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getDownloadReceiptQueryKey = (id: number) => {
  return [`/api/receipts/${id}/download`] as const;
};

export const getDownloadReceiptQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadReceipt>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadReceipt>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDownloadReceiptQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadReceipt>>> = ({
    signal,
  }) => downloadReceipt(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadReceipt>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DownloadReceiptQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadReceipt>>
>;
export type DownloadReceiptQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Download receipt file
 */

export function useDownloadReceipt<
  TData = Awaited<ReturnType<typeof downloadReceipt>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadReceipt>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDownloadReceiptQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Run matching for a statement
 */
export const getMatchStatementUrl = (id: number) => {
  return `/api/statements/${id}/match`;
};

export const matchStatement = async (
  id: number,
  options?: RequestInit,
): Promise<MatchResult> => {
  return customFetch<MatchResult>(getMatchStatementUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getMatchStatementMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof matchStatement>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof matchStatement>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["matchStatement"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof matchStatement>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return matchStatement(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MatchStatementMutationResult = NonNullable<
  Awaited<ReturnType<typeof matchStatement>>
>;

export type MatchStatementMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Run matching for a statement
 */
export const useMatchStatement = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof matchStatement>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof matchStatement>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getMatchStatementMutationOptions(options));
};

/**
 * @summary List match failures for review
 */
export const getListMatchFailuresUrl = (params?: ListMatchFailuresParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/match-failures?${stringifiedParams}`
    : `/api/match-failures`;
};

export const listMatchFailures = async (
  params?: ListMatchFailuresParams,
  options?: RequestInit,
): Promise<MatchFailure[]> => {
  return customFetch<MatchFailure[]>(getListMatchFailuresUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListMatchFailuresQueryKey = (
  params?: ListMatchFailuresParams,
) => {
  return [`/api/match-failures`, ...(params ? [params] : [])] as const;
};

export const getListMatchFailuresQueryOptions = <
  TData = Awaited<ReturnType<typeof listMatchFailures>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMatchFailuresParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMatchFailures>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListMatchFailuresQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listMatchFailures>>
  > = ({ signal }) => listMatchFailures(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMatchFailures>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMatchFailuresQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMatchFailures>>
>;
export type ListMatchFailuresQueryError = ErrorType<unknown>;

/**
 * @summary List match failures for review
 */

export function useListMatchFailures<
  TData = Awaited<ReturnType<typeof listMatchFailures>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMatchFailuresParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMatchFailures>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMatchFailuresQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Manually resolve a match failure
 */
export const getResolveMatchFailureUrl = (id: number) => {
  return `/api/match-failures/${id}/resolve`;
};

export const resolveMatchFailure = async (
  id: number,
  resolveMatchBody: ResolveMatchBody,
  options?: RequestInit,
): Promise<MessageResponse> => {
  return customFetch<MessageResponse>(getResolveMatchFailureUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(resolveMatchBody),
  });
};

export const getResolveMatchFailureMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resolveMatchFailure>>,
    TError,
    { id: number; data: BodyType<ResolveMatchBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resolveMatchFailure>>,
  TError,
  { id: number; data: BodyType<ResolveMatchBody> },
  TContext
> => {
  const mutationKey = ["resolveMatchFailure"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resolveMatchFailure>>,
    { id: number; data: BodyType<ResolveMatchBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return resolveMatchFailure(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResolveMatchFailureMutationResult = NonNullable<
  Awaited<ReturnType<typeof resolveMatchFailure>>
>;
export type ResolveMatchFailureMutationBody = BodyType<ResolveMatchBody>;
export type ResolveMatchFailureMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Manually resolve a match failure
 */
export const useResolveMatchFailure = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resolveMatchFailure>>,
    TError,
    { id: number; data: BodyType<ResolveMatchBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resolveMatchFailure>>,
  TError,
  { id: number; data: BodyType<ResolveMatchBody> },
  TContext
> => {
  return useMutation(getResolveMatchFailureMutationOptions(options));
};

/**
 * @summary Manually assign a receipt to a statement entry
 */
export const getManualAssignUrl = (id: number, entryId: number) => {
  return `/api/statements/${id}/entries/${entryId}/assign`;
};

export const manualAssign = async (
  id: number,
  entryId: number,
  manualAssignBody: ManualAssignBody,
  options?: RequestInit,
): Promise<MessageResponse> => {
  return customFetch<MessageResponse>(getManualAssignUrl(id, entryId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(manualAssignBody),
  });
};

export const getManualAssignMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof manualAssign>>,
    TError,
    { id: number; entryId: number; data: BodyType<ManualAssignBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof manualAssign>>,
  TError,
  { id: number; entryId: number; data: BodyType<ManualAssignBody> },
  TContext
> => {
  const mutationKey = ["manualAssign"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof manualAssign>>,
    { id: number; entryId: number; data: BodyType<ManualAssignBody> }
  > = (props) => {
    const { id, entryId, data } = props ?? {};

    return manualAssign(id, entryId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ManualAssignMutationResult = NonNullable<
  Awaited<ReturnType<typeof manualAssign>>
>;
export type ManualAssignMutationBody = BodyType<ManualAssignBody>;
export type ManualAssignMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Manually assign a receipt to a statement entry
 */
export const useManualAssign = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof manualAssign>>,
    TError,
    { id: number; entryId: number; data: BodyType<ManualAssignBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof manualAssign>>,
  TError,
  { id: number; entryId: number; data: BodyType<ManualAssignBody> },
  TContext
> => {
  return useMutation(getManualAssignMutationOptions(options));
};

/**
 * @summary Send email reminders for unmatched entries
 */
export const getSendRemindersUrl = (id: number) => {
  return `/api/statements/${id}/send-reminders`;
};

export const sendReminders = async (
  id: number,
  options?: RequestInit,
): Promise<ReminderResult> => {
  return customFetch<ReminderResult>(getSendRemindersUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getSendRemindersMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendReminders>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendReminders>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["sendReminders"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendReminders>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return sendReminders(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendRemindersMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendReminders>>
>;

export type SendRemindersMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Send email reminders for unmatched entries
 */
export const useSendReminders = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendReminders>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendReminders>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getSendRemindersMutationOptions(options));
};

/**
 * @summary Get SMTP settings
 */
export const getGetSmtpSettingsUrl = () => {
  return `/api/settings/smtp`;
};

export const getSmtpSettings = async (
  options?: RequestInit,
): Promise<SmtpSettings> => {
  return customFetch<SmtpSettings>(getGetSmtpSettingsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetSmtpSettingsQueryKey = () => {
  return [`/api/settings/smtp`] as const;
};

export const getGetSmtpSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSmtpSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getSmtpSettings>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSmtpSettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSmtpSettings>>> = ({
    signal,
  }) => getSmtpSettings({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSmtpSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSmtpSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSmtpSettings>>
>;
export type GetSmtpSettingsQueryError = ErrorType<unknown>;

/**
 * @summary Get SMTP settings
 */

export function useGetSmtpSettings<
  TData = Awaited<ReturnType<typeof getSmtpSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getSmtpSettings>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSmtpSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update SMTP settings
 */
export const getUpdateSmtpSettingsUrl = () => {
  return `/api/settings/smtp`;
};

export const updateSmtpSettings = async (
  smtpSettingsBody: SmtpSettingsBody,
  options?: RequestInit,
): Promise<SmtpSettings> => {
  return customFetch<SmtpSettings>(getUpdateSmtpSettingsUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(smtpSettingsBody),
  });
};

export const getUpdateSmtpSettingsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSmtpSettings>>,
    TError,
    { data: BodyType<SmtpSettingsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSmtpSettings>>,
  TError,
  { data: BodyType<SmtpSettingsBody> },
  TContext
> => {
  const mutationKey = ["updateSmtpSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSmtpSettings>>,
    { data: BodyType<SmtpSettingsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateSmtpSettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSmtpSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSmtpSettings>>
>;
export type UpdateSmtpSettingsMutationBody = BodyType<SmtpSettingsBody>;
export type UpdateSmtpSettingsMutationError = ErrorType<unknown>;

/**
 * @summary Update SMTP settings
 */
export const useUpdateSmtpSettings = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSmtpSettings>>,
    TError,
    { data: BodyType<SmtpSettingsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSmtpSettings>>,
  TError,
  { data: BodyType<SmtpSettingsBody> },
  TContext
> => {
  return useMutation(getUpdateSmtpSettingsMutationOptions(options));
};

/**
 * @summary Get the current bank-details remittance reply setting
 */
export const getGetBankDetailsNoticeSettingsUrl = () => {
  return `/api/settings/bank-details-notice`;
};

export const getBankDetailsNoticeSettings = async (
  options?: RequestInit,
): Promise<BankDetailsNoticeSettings> => {
  return customFetch<BankDetailsNoticeSettings>(
    getGetBankDetailsNoticeSettingsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetBankDetailsNoticeSettingsQueryKey = () => {
  return [`/api/settings/bank-details-notice`] as const;
};

export const getGetBankDetailsNoticeSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getBankDetailsNoticeSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getBankDetailsNoticeSettings>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBankDetailsNoticeSettingsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBankDetailsNoticeSettings>>
  > = ({ signal }) =>
    getBankDetailsNoticeSettings({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBankDetailsNoticeSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBankDetailsNoticeSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBankDetailsNoticeSettings>>
>;
export type GetBankDetailsNoticeSettingsQueryError = ErrorType<unknown>;

/**
 * @summary Get the current bank-details remittance reply setting
 */

export function useGetBankDetailsNoticeSettings<
  TData = Awaited<ReturnType<typeof getBankDetailsNoticeSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getBankDetailsNoticeSettings>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBankDetailsNoticeSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Enable or disable automatic bank-details replies (super admin only)
 */
export const getUpdateBankDetailsNoticeSettingsUrl = () => {
  return `/api/settings/bank-details-notice`;
};

export const updateBankDetailsNoticeSettings = async (
  bankDetailsNoticeToggle: BankDetailsNoticeToggle,
  options?: RequestInit,
): Promise<BankDetailsNoticeSettings> => {
  return customFetch<BankDetailsNoticeSettings>(
    getUpdateBankDetailsNoticeSettingsUrl(),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(bankDetailsNoticeToggle),
    },
  );
};

export const getUpdateBankDetailsNoticeSettingsMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBankDetailsNoticeSettings>>,
    TError,
    { data: BodyType<BankDetailsNoticeToggle> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBankDetailsNoticeSettings>>,
  TError,
  { data: BodyType<BankDetailsNoticeToggle> },
  TContext
> => {
  const mutationKey = ["updateBankDetailsNoticeSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBankDetailsNoticeSettings>>,
    { data: BodyType<BankDetailsNoticeToggle> }
  > = (props) => {
    const { data } = props ?? {};

    return updateBankDetailsNoticeSettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBankDetailsNoticeSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBankDetailsNoticeSettings>>
>;
export type UpdateBankDetailsNoticeSettingsMutationBody =
  BodyType<BankDetailsNoticeToggle>;
export type UpdateBankDetailsNoticeSettingsMutationError =
  ErrorType<ErrorResponse>;

/**
 * @summary Enable or disable automatic bank-details replies (super admin only)
 */
export const useUpdateBankDetailsNoticeSettings = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBankDetailsNoticeSettings>>,
    TError,
    { data: BodyType<BankDetailsNoticeToggle> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateBankDetailsNoticeSettings>>,
  TError,
  { data: BodyType<BankDetailsNoticeToggle> },
  TContext
> => {
  return useMutation(
    getUpdateBankDetailsNoticeSettingsMutationOptions(options),
  );
};

/**
 * @summary Send a test of the notice to the signed-in user's email only
 */
export const getSendBankDetailsNoticeTestUrl = () => {
  return `/api/settings/bank-details-notice/test`;
};

export const sendBankDetailsNoticeTest = async (
  options?: RequestInit,
): Promise<BankDetailsNoticeTestResult> => {
  return customFetch<BankDetailsNoticeTestResult>(
    getSendBankDetailsNoticeTestUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getSendBankDetailsNoticeTestMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendBankDetailsNoticeTest>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendBankDetailsNoticeTest>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["sendBankDetailsNoticeTest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendBankDetailsNoticeTest>>,
    void
  > = () => {
    return sendBankDetailsNoticeTest(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendBankDetailsNoticeTestMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendBankDetailsNoticeTest>>
>;

export type SendBankDetailsNoticeTestMutationError = ErrorType<unknown>;

/**
 * @summary Send a test of the notice to the signed-in user's email only
 */
export const useSendBankDetailsNoticeTest = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendBankDetailsNoticeTest>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendBankDetailsNoticeTest>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getSendBankDetailsNoticeTestMutationOptions(options));
};

/**
 * @summary List cardholders with their email assignments
 */
export const getListCardholdersUrl = () => {
  return `/api/cardholders`;
};

export const listCardholders = async (
  options?: RequestInit,
): Promise<Cardholder[]> => {
  return customFetch<Cardholder[]>(getListCardholdersUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListCardholdersQueryKey = () => {
  return [`/api/cardholders`] as const;
};

export const getListCardholdersQueryOptions = <
  TData = Awaited<ReturnType<typeof listCardholders>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCardholders>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCardholdersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCardholders>>> = ({
    signal,
  }) => listCardholders({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCardholders>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCardholdersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCardholders>>
>;
export type ListCardholdersQueryError = ErrorType<unknown>;

/**
 * @summary List cardholders with their email assignments
 */

export function useListCardholders<
  TData = Awaited<ReturnType<typeof listCardholders>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCardholders>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCardholdersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update cardholder email
 */
export const getUpdateCardholderUrl = (id: number) => {
  return `/api/cardholders/${id}`;
};

export const updateCardholder = async (
  id: number,
  updateCardholderBody: UpdateCardholderBody,
  options?: RequestInit,
): Promise<Cardholder> => {
  return customFetch<Cardholder>(getUpdateCardholderUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateCardholderBody),
  });
};

export const getUpdateCardholderMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCardholder>>,
    TError,
    { id: number; data: BodyType<UpdateCardholderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCardholder>>,
  TError,
  { id: number; data: BodyType<UpdateCardholderBody> },
  TContext
> => {
  const mutationKey = ["updateCardholder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCardholder>>,
    { id: number; data: BodyType<UpdateCardholderBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateCardholder(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCardholderMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCardholder>>
>;
export type UpdateCardholderMutationBody = BodyType<UpdateCardholderBody>;
export type UpdateCardholderMutationError = ErrorType<unknown>;

/**
 * @summary Update cardholder email
 */
export const useUpdateCardholder = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCardholder>>,
    TError,
    { id: number; data: BodyType<UpdateCardholderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCardholder>>,
  TError,
  { id: number; data: BodyType<UpdateCardholderBody> },
  TContext
> => {
  return useMutation(getUpdateCardholderMutationOptions(options));
};

/**
 * @summary Get all nominal code templates
 */
export const getGetNominalTemplatesUrl = () => {
  return `/api/nominal-templates`;
};

export const getNominalTemplates = async (
  options?: RequestInit,
): Promise<NominalTemplate[]> => {
  return customFetch<NominalTemplate[]>(getGetNominalTemplatesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetNominalTemplatesQueryKey = () => {
  return [`/api/nominal-templates`] as const;
};

export const getGetNominalTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getNominalTemplates>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getNominalTemplates>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNominalTemplatesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getNominalTemplates>>
  > = ({ signal }) => getNominalTemplates({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNominalTemplates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNominalTemplatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNominalTemplates>>
>;
export type GetNominalTemplatesQueryError = ErrorType<unknown>;

/**
 * @summary Get all nominal code templates
 */

export function useGetNominalTemplates<
  TData = Awaited<ReturnType<typeof getNominalTemplates>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getNominalTemplates>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetNominalTemplatesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a nominal code template
 */
export const getCreateNominalTemplateUrl = () => {
  return `/api/nominal-templates`;
};

export const createNominalTemplate = async (
  createNominalTemplateBody: CreateNominalTemplateBody,
  options?: RequestInit,
): Promise<NominalTemplate> => {
  return customFetch<NominalTemplate>(getCreateNominalTemplateUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createNominalTemplateBody),
  });
};

export const getCreateNominalTemplateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createNominalTemplate>>,
    TError,
    { data: BodyType<CreateNominalTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createNominalTemplate>>,
  TError,
  { data: BodyType<CreateNominalTemplateBody> },
  TContext
> => {
  const mutationKey = ["createNominalTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createNominalTemplate>>,
    { data: BodyType<CreateNominalTemplateBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createNominalTemplate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateNominalTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createNominalTemplate>>
>;
export type CreateNominalTemplateMutationBody =
  BodyType<CreateNominalTemplateBody>;
export type CreateNominalTemplateMutationError = ErrorType<unknown>;

/**
 * @summary Create a nominal code template
 */
export const useCreateNominalTemplate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createNominalTemplate>>,
    TError,
    { data: BodyType<CreateNominalTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createNominalTemplate>>,
  TError,
  { data: BodyType<CreateNominalTemplateBody> },
  TContext
> => {
  return useMutation(getCreateNominalTemplateMutationOptions(options));
};

/**
 * @summary Update a nominal code template
 */
export const getUpdateNominalTemplateUrl = (id: number) => {
  return `/api/nominal-templates/${id}`;
};

export const updateNominalTemplate = async (
  id: number,
  createNominalTemplateBody: CreateNominalTemplateBody,
  options?: RequestInit,
): Promise<NominalTemplate> => {
  return customFetch<NominalTemplate>(getUpdateNominalTemplateUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createNominalTemplateBody),
  });
};

export const getUpdateNominalTemplateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNominalTemplate>>,
    TError,
    { id: number; data: BodyType<CreateNominalTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateNominalTemplate>>,
  TError,
  { id: number; data: BodyType<CreateNominalTemplateBody> },
  TContext
> => {
  const mutationKey = ["updateNominalTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateNominalTemplate>>,
    { id: number; data: BodyType<CreateNominalTemplateBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateNominalTemplate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateNominalTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateNominalTemplate>>
>;
export type UpdateNominalTemplateMutationBody =
  BodyType<CreateNominalTemplateBody>;
export type UpdateNominalTemplateMutationError = ErrorType<unknown>;

/**
 * @summary Update a nominal code template
 */
export const useUpdateNominalTemplate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNominalTemplate>>,
    TError,
    { id: number; data: BodyType<CreateNominalTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateNominalTemplate>>,
  TError,
  { id: number; data: BodyType<CreateNominalTemplateBody> },
  TContext
> => {
  return useMutation(getUpdateNominalTemplateMutationOptions(options));
};

/**
 * @summary Delete a nominal code template
 */
export const getDeleteNominalTemplateUrl = (id: number) => {
  return `/api/nominal-templates/${id}`;
};

export const deleteNominalTemplate = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteNominalTemplate200> => {
  return customFetch<DeleteNominalTemplate200>(
    getDeleteNominalTemplateUrl(id),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteNominalTemplateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteNominalTemplate>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteNominalTemplate>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteNominalTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteNominalTemplate>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteNominalTemplate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteNominalTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteNominalTemplate>>
>;

export type DeleteNominalTemplateMutationError = ErrorType<unknown>;

/**
 * @summary Delete a nominal code template
 */
export const useDeleteNominalTemplate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteNominalTemplate>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteNominalTemplate>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteNominalTemplateMutationOptions(options));
};

/**
 * @summary Analyze a receipt using AI to break down line items
 */
export const getAnalyzeReceiptBreakdownUrl = () => {
  return `/api/nominal-assignments/analyze`;
};

export const analyzeReceiptBreakdown = async (
  analyzeReceiptBody: AnalyzeReceiptBody,
  options?: RequestInit,
): Promise<BreakdownResult> => {
  return customFetch<BreakdownResult>(getAnalyzeReceiptBreakdownUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(analyzeReceiptBody),
  });
};

export const getAnalyzeReceiptBreakdownMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof analyzeReceiptBreakdown>>,
    TError,
    { data: BodyType<AnalyzeReceiptBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof analyzeReceiptBreakdown>>,
  TError,
  { data: BodyType<AnalyzeReceiptBody> },
  TContext
> => {
  const mutationKey = ["analyzeReceiptBreakdown"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof analyzeReceiptBreakdown>>,
    { data: BodyType<AnalyzeReceiptBody> }
  > = (props) => {
    const { data } = props ?? {};

    return analyzeReceiptBreakdown(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AnalyzeReceiptBreakdownMutationResult = NonNullable<
  Awaited<ReturnType<typeof analyzeReceiptBreakdown>>
>;
export type AnalyzeReceiptBreakdownMutationBody = BodyType<AnalyzeReceiptBody>;
export type AnalyzeReceiptBreakdownMutationError = ErrorType<unknown>;

/**
 * @summary Analyze a receipt using AI to break down line items
 */
export const useAnalyzeReceiptBreakdown = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof analyzeReceiptBreakdown>>,
    TError,
    { data: BodyType<AnalyzeReceiptBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof analyzeReceiptBreakdown>>,
  TError,
  { data: BodyType<AnalyzeReceiptBody> },
  TContext
> => {
  return useMutation(getAnalyzeReceiptBreakdownMutationOptions(options));
};

/**
 * @summary Save nominal code assignments for a statement entry
 */
export const getSaveNominalAssignmentUrl = () => {
  return `/api/nominal-assignments`;
};

export const saveNominalAssignment = async (
  saveNominalAssignmentBody: SaveNominalAssignmentBody,
  options?: RequestInit,
): Promise<NominalAssignment[]> => {
  return customFetch<NominalAssignment[]>(getSaveNominalAssignmentUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(saveNominalAssignmentBody),
  });
};

export const getSaveNominalAssignmentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveNominalAssignment>>,
    TError,
    { data: BodyType<SaveNominalAssignmentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveNominalAssignment>>,
  TError,
  { data: BodyType<SaveNominalAssignmentBody> },
  TContext
> => {
  const mutationKey = ["saveNominalAssignment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveNominalAssignment>>,
    { data: BodyType<SaveNominalAssignmentBody> }
  > = (props) => {
    const { data } = props ?? {};

    return saveNominalAssignment(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveNominalAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveNominalAssignment>>
>;
export type SaveNominalAssignmentMutationBody =
  BodyType<SaveNominalAssignmentBody>;
export type SaveNominalAssignmentMutationError = ErrorType<unknown>;

/**
 * @summary Save nominal code assignments for a statement entry
 */
export const useSaveNominalAssignment = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveNominalAssignment>>,
    TError,
    { data: BodyType<SaveNominalAssignmentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveNominalAssignment>>,
  TError,
  { data: BodyType<SaveNominalAssignmentBody> },
  TContext
> => {
  return useMutation(getSaveNominalAssignmentMutationOptions(options));
};

/**
 * @summary Get nominal assignments for a statement entry
 */
export const getGetNominalAssignmentsForEntryUrl = (entryId: number) => {
  return `/api/nominal-assignments/entry/${entryId}`;
};

export const getNominalAssignmentsForEntry = async (
  entryId: number,
  options?: RequestInit,
): Promise<NominalAssignment[]> => {
  return customFetch<NominalAssignment[]>(
    getGetNominalAssignmentsForEntryUrl(entryId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetNominalAssignmentsForEntryQueryKey = (entryId: number) => {
  return [`/api/nominal-assignments/entry/${entryId}`] as const;
};

export const getGetNominalAssignmentsForEntryQueryOptions = <
  TData = Awaited<ReturnType<typeof getNominalAssignmentsForEntry>>,
  TError = ErrorType<unknown>,
>(
  entryId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getNominalAssignmentsForEntry>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetNominalAssignmentsForEntryQueryKey(entryId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getNominalAssignmentsForEntry>>
  > = ({ signal }) =>
    getNominalAssignmentsForEntry(entryId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!entryId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getNominalAssignmentsForEntry>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNominalAssignmentsForEntryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNominalAssignmentsForEntry>>
>;
export type GetNominalAssignmentsForEntryQueryError = ErrorType<unknown>;

/**
 * @summary Get nominal assignments for a statement entry
 */

export function useGetNominalAssignmentsForEntry<
  TData = Awaited<ReturnType<typeof getNominalAssignmentsForEntry>>,
  TError = ErrorType<unknown>,
>(
  entryId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getNominalAssignmentsForEntry>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetNominalAssignmentsForEntryQueryOptions(
    entryId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Delete all nominal assignments for a statement entry
 */
export const getDeleteNominalAssignmentsForEntryUrl = (entryId: number) => {
  return `/api/nominal-assignments/entry/${entryId}`;
};

export const deleteNominalAssignmentsForEntry = async (
  entryId: number,
  options?: RequestInit,
): Promise<DeleteNominalAssignmentsForEntry200> => {
  return customFetch<DeleteNominalAssignmentsForEntry200>(
    getDeleteNominalAssignmentsForEntryUrl(entryId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteNominalAssignmentsForEntryMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteNominalAssignmentsForEntry>>,
    TError,
    { entryId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteNominalAssignmentsForEntry>>,
  TError,
  { entryId: number },
  TContext
> => {
  const mutationKey = ["deleteNominalAssignmentsForEntry"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteNominalAssignmentsForEntry>>,
    { entryId: number }
  > = (props) => {
    const { entryId } = props ?? {};

    return deleteNominalAssignmentsForEntry(entryId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteNominalAssignmentsForEntryMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteNominalAssignmentsForEntry>>
>;

export type DeleteNominalAssignmentsForEntryMutationError = ErrorType<unknown>;

/**
 * @summary Delete all nominal assignments for a statement entry
 */
export const useDeleteNominalAssignmentsForEntry = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteNominalAssignmentsForEntry>>,
    TError,
    { entryId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteNominalAssignmentsForEntry>>,
  TError,
  { entryId: number },
  TContext
> => {
  return useMutation(
    getDeleteNominalAssignmentsForEntryMutationOptions(options),
  );
};

/**
 * @summary Get all nominal assignments for a statement
 */
export const getGetNominalAssignmentsForStatementUrl = (
  statementId: number,
) => {
  return `/api/nominal-assignments/statement/${statementId}`;
};

export const getNominalAssignmentsForStatement = async (
  statementId: number,
  options?: RequestInit,
): Promise<NominalAssignment[]> => {
  return customFetch<NominalAssignment[]>(
    getGetNominalAssignmentsForStatementUrl(statementId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetNominalAssignmentsForStatementQueryKey = (
  statementId: number,
) => {
  return [`/api/nominal-assignments/statement/${statementId}`] as const;
};

export const getGetNominalAssignmentsForStatementQueryOptions = <
  TData = Awaited<ReturnType<typeof getNominalAssignmentsForStatement>>,
  TError = ErrorType<unknown>,
>(
  statementId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getNominalAssignmentsForStatement>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetNominalAssignmentsForStatementQueryKey(statementId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getNominalAssignmentsForStatement>>
  > = ({ signal }) =>
    getNominalAssignmentsForStatement(statementId, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!statementId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getNominalAssignmentsForStatement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNominalAssignmentsForStatementQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNominalAssignmentsForStatement>>
>;
export type GetNominalAssignmentsForStatementQueryError = ErrorType<unknown>;

/**
 * @summary Get all nominal assignments for a statement
 */

export function useGetNominalAssignmentsForStatement<
  TData = Awaited<ReturnType<typeof getNominalAssignmentsForStatement>>,
  TError = ErrorType<unknown>,
>(
  statementId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getNominalAssignmentsForStatement>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetNominalAssignmentsForStatementQueryOptions(
    statementId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Search warehouse collection proof-of-delivery photos
 */
export const getSearchPodCollectionsUrl = (
  params?: SearchPodCollectionsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/pod-collections?${stringifiedParams}`
    : `/api/pod-collections`;
};

export const searchPodCollections = async (
  params?: SearchPodCollectionsParams,
  options?: RequestInit,
): Promise<PodCollectionList> => {
  return customFetch<PodCollectionList>(getSearchPodCollectionsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getSearchPodCollectionsQueryKey = (
  params?: SearchPodCollectionsParams,
) => {
  return [`/api/pod-collections`, ...(params ? [params] : [])] as const;
};

export const getSearchPodCollectionsQueryOptions = <
  TData = Awaited<ReturnType<typeof searchPodCollections>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: SearchPodCollectionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof searchPodCollections>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSearchPodCollectionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchPodCollections>>
  > = ({ signal }) =>
    searchPodCollections(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchPodCollections>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SearchPodCollectionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchPodCollections>>
>;
export type SearchPodCollectionsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Search warehouse collection proof-of-delivery photos
 */

export function useSearchPodCollections<
  TData = Awaited<ReturnType<typeof searchPodCollections>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: SearchPodCollectionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof searchPodCollections>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSearchPodCollectionsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Proxies the proof-of-delivery photo from the warehouse API so the bearer key never reaches the browser. Loaded directly via an <img> src, not through the typed client.
 * @summary Stream a collection POD photo
 */
export const getGetPodCollectionImageUrl = (id: number) => {
  return `/api/pod-collections/${id}/image`;
};

export const getPodCollectionImage = async (
  id: number,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getGetPodCollectionImageUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetPodCollectionImageQueryKey = (id: number) => {
  return [`/api/pod-collections/${id}/image`] as const;
};

export const getGetPodCollectionImageQueryOptions = <
  TData = Awaited<ReturnType<typeof getPodCollectionImage>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPodCollectionImage>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPodCollectionImageQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPodCollectionImage>>
  > = ({ signal }) => getPodCollectionImage(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPodCollectionImage>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPodCollectionImageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPodCollectionImage>>
>;
export type GetPodCollectionImageQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Stream a collection POD photo
 */

export function useGetPodCollectionImage<
  TData = Awaited<ReturnType<typeof getPodCollectionImage>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPodCollectionImage>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPodCollectionImageQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}
